import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e48ed566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history-table" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"history-table__title-row\" data-v-e48ed566><div class=\"name-date\" data-v-e48ed566><div class=\"name-date__name\" data-v-e48ed566> Название </div><div class=\"name-date__date\" data-v-e48ed566> Дата и время </div></div><div class=\"name\" data-v-e48ed566> Название </div><div class=\"date\" data-v-e48ed566> Дата и время </div><div class=\"scores\" data-v-e48ed566> Бонусные баллы </div></div>", 1)
const _hoisted_3 = { class: "history-table__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: _normalizeClass({
          'history-table__item': true,
          'history-table__item--fill': index % 2 === 1,
        })
        }, [
          _createVNode(_component_Item, { item: item }, null, 8, ["item"])
        ], 2))
      }), 128))
    ])
  ]))
}